import { useContext } from 'react';
import { NotificationsContext } from '../../components/Notifications';

export function useNotifications() {
  const { sendNotification, sendConfirmation, setMetadata } = useContext(NotificationsContext);
  return [sendNotification, sendConfirmation, setMetadata];
}
